import * as React from 'react';
import { MDate } from '../../utils/dateUtil';
import { MonthlyCountData } from '../../utils/MonthlyCountData';
import { TYPE } from '../../constants/Training';

export const WEEK_NAMES: string[] = ['日', '月', '火', '水', '木', '金', '土'];

// 月曜開始版.
export const MON_START_WEEK_NAMES: string[] = ['月', '火', '水', '木', '金', '土', '日'];

// ローディング中のダミー・カレンダー部分.
export class DummyCalendar extends React.Component {
  render() {
    // ダミーなので現在.
    const mDate: MDate = new MDate();
    const calender = mDate.makeCalendar(Number(mDate.year), Number(mDate.month));

    let calWeek: JSX.Element[] = [];
    WEEK_NAMES.forEach((week: string, i: number) => {
      const key = `week${i}`;
      calWeek.push(<th key={key}>{week}</th>);
    });

    return (
      <div className="calendar">
        <table id="calendar" className="table table-bordered">
          <thead>
            <tr>
              {calWeek}
            </tr>
          </thead>
          <tbody>
            {
              calender.map((week: {day: number|string}[], index: number) => {
                const key = `calender${index}`;
                return <tr key={key}> 
                {
                  week.map((day: {day: number|string}, weekIndex: number) => {
                    const keyWeek = `calennderWeek${index}-${weekIndex}`;
                    return <td key={keyWeek}>{day.day}</td>;
                  })}
                </tr>;
              })}
          </tbody>
        </table>
      </div>
    );
  }
}

interface CalendarProps extends React.Props<{}> {
  history: any;

  // 親からの引き渡し用.
  mDate: MDate;

  type: TYPE;
}

// カレンダー部分.
export default class Calendar extends React.Component<CalendarProps, {}> {
  mDate: MDate;

  render() {
    const monthlyCountData = new MonthlyCountData(this.props.type);
    monthlyCountData.insertData(this.props.history);

    // 日付に記録があるかどうか.
    // カレンダーのactive用のみ.
    const historyDateFlag = monthlyCountData.dateFlag;

    this.mDate = this.props.mDate;
    const calender = this.mDate.makeCalendar(Number(this.mDate.year), Number(this.mDate.month));

    let calWeek: JSX.Element[] = [];
    WEEK_NAMES.forEach((week: string, i: number) => {
      const key = `week${i}`;
      calWeek.push(<th key={key}>{week}</th>);
    });

    return (
      <div className="calendar">
        <table id="calendar" className="table table-bordered">
          <thead>
            <tr>
              {calWeek}
            </tr>
          </thead>
          <tbody>
            {
              calender.map((week: {day: number|string}[], index: number) => {
                const key = `calender${index}`;
                return <tr key={key}> 
                {
                  week.map((day: {day: number|string}, weekIndex: number) => {
                    const keyWeek = `calennderWeek${index}-${weekIndex}`;
                    return <td key={keyWeek} className={historyDateFlag[day.day] ? 'active' : ''}>{day.day}</td>;
                  })}
                </tr>;
              })}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Calendar.tsx